import type { BatchActionButtonProps } from '../types'

import { Button } from 'antd'
import cx from 'classnames'

export function BatchActionButton({
  children,
  type: _type = 'default',
  className,
  ...props
}: BatchActionButtonProps): JSX.Element {
  return (
    <Button
      htmlType='button'
      className={cx(
        'bg-white font-lato font-semibold text-xs uppercase text-blue-500 border border-blue-400',
        className
      )}
      {...props}
    >
      {children}
    </Button>
  )
}
